import { OverrideLiquidColumnsSchemaValues } from '@/zod/schemas/dataSource/Common';

export const getOverrideLiquidColumnsValues = (
  columns: string[],
): OverrideLiquidColumnsSchemaValues => {
  return {
    enableOverrideLiquidColumns: !!columns?.length,
    overrideLiquidColumns: columns?.length ? columns : [''],
  };
};
